export default "__VITE_ASSET__9b2da1e9__"